import {DeltaHandler} from "../../../infrastructure/handlers/delta-handler";
import {AthletePropositionBetModuleState} from "../models/athlete-proposition-bet-module.state";
import {AthletePropositionBetModuleController} from "../athlete-proposition-bet-module.controller";
import {PropositionBetsDomainService} from "../../../domain/bets/proposition/services/proposition-bets.domain-service";
import {ACTION_TYPES, COMPONENT_STATES} from "../../../core/consts";
import {PropositionBetsRequestParams} from "../../../domain/bets/proposition/models/proposition-bets.request-params";

export class AthletePropositionBetModuleFetchHandler extends DeltaHandler {
  controller: AthletePropositionBetModuleController;
  state: AthletePropositionBetModuleState;

  static injectables = [PropositionBetsDomainService];

  onLoaded() {
    super.onLoaded();

    if(this.controller.props.propositionBets === undefined) {
      this.action();
    } else {
      this.store.setComponentState(COMPONENT_STATES.loaded);
    }
  }

  get requestParams(): PropositionBetsRequestParams {
    const gameId: Number = this.controller.props.gameId;
    const athleteId = this.controller.props.athleteId;
    const topBookmakerId :Number = this.state.appState.topBookmakerId;

    const requestParams: PropositionBetsRequestParams = new PropositionBetsRequestParams(gameId, athleteId, topBookmakerId);

    return requestParams;
  }

  async action() {
    const dataSource = await super.fetch();

    this.controller.action(ACTION_TYPES.populateData, {dataSource})
  }

  populateDelta(response) {
    this.controller.action(ACTION_TYPES.populateData, {dataSource: response});
  }

  async onDidUpdate(prevProps, nextProps) {
    super.onDidUpdate(prevProps, nextProps);

    const isAthleteChanged: Boolean = prevProps?.athleteId !== nextProps?.athleteId;

    if (isAthleteChanged) {

      if(this.controller.props.propositionBets === undefined) {
        await this.action();
      }
    }
  }

}
